import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
Vue.use(VueRouter)
const routes: Array<RouteConfig> = [
  {
    path: '/sk',
    redirect: '/sgs',
  },
  {
    path: '/zqy',
    redirect: '/bari',
  },
  {
    path: '/',
    redirect: '/homes',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home/home.vue'),
    meta: {
      keepAlive: true,
      show: false,
      activeNum: 1,
      title: '预约检测',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register/register.vue'),
  },
  {
    path: '/center',
    name: 'Center',
    component: () => import('@/views/Center/center.vue'),
    meta: {
      show: true,
      activeNum: 2,
      title: '中心店',
    },
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('@/views/Service/service.vue'),
    meta: {
      // show: true,
      // activeNum: 2,
    },
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/My/my.vue'),
    meta: {
      show: true,
      activeNum: 3,
      title: '卫蓝e站',
    },
  },
  {
    path: '/protocol',
    name: 'Protocol',
    component: () => import('@/views/Protocol/protocol.vue'),
  },
  {
    path: '/Home/success',
    name: 'Success',
    component: () => import('@/views/Home/success.vue'),
  },
  {
    path: '/My/my_bookings',
    name: 'My_Bookings',
    component: () => import('@/views/My/my_bookings.vue'),
  },
  {
    path: '/My/OrderManagement',
    name: 'OrderManagement',
    component: () => import('@/views/My/OrderManagement.vue'),
    meta: {
      keepAlive: true,
    },
  },

  {
    path: '/My/my-detail/:status?',
    name: 'Mydetail',
    component: () => import('@/views/My/my-detail.vue'),
  },

  {
    path: '/My/clientEnd',
    name: 'ClientEnd',
    component: () => import('@/views/My/clientEnd.vue'),
    meta: {
      keepAlive: true,
    },
  },

  {
    path: '/My/my_reports',
    name: 'My_Reports',
    component: () => import('@/views/My/my_reports.vue'),
  },

  {
    path: '/My/my_bookings',
    name: 'My_Bookings',
    component: () => import('@/views/My/my_bookings.vue'),
  },

  {
    path: '/My/my_booking_manage',
    name: 'My_Booking_Manage',
    component: () => import('@/views/My/my_booking_manage.vue'),
  },
  {
    path: '/My/my_booking_manage_details',
    name: 'My_Booking_Manage_Details',
    component: () => import('@/views/My/my_booking_manage_details.vue'),
  },
  {
    path: '/My/personal',
    name: 'Personal',
    component: () => import('@/views/My/personal.vue'),
  },
  {
    path: '/My/labor',
    name: 'Labor',
    component: () => import('@/views/My/labor.vue'),
  },
  {
    path: '/My/coupon',
    name: 'Coupon',
    component: () => import('@/views/My/coupon.vue'),
  },
  {
    path: '/sgs',
    name: 'Sgs',
    component: () => import('@/views/Sgs/sgs.vue'),
  },
  {
    path: '/brand',
    name: 'Brand',
    component: () => import('@/views/Brand/brand.vue'),
  },
  {
    path: '/carsbrand',
    name: 'Carsbrand',
    component: () => import('@/views/Brand/carsbrand.vue'),
  },
  {
    path: '/yearbrand',
    name: 'Yearbrand',
    component: () => import('@/views/Brand/yearbrand.vue'),
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('@/views/Index/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/example',
    name: 'Example',
    component: () => import('@/views/Index/example.vue'),
  },
  {
    path: '/guide',
    name: 'Guide',
    component: () => import('@/views/Index/guide.vue'),
  },
  {
    path: '/signature',
    name: 'Signature',
    component: () => import('@/views/Index/signature.vue'),
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/Index/agreement.vue'),
  },
  {
    path: '/region',
    name: 'Region',
    component: () => import('@/views/Region/region.vue'),
  },
  {
    path: '/Bari',
    name: 'bari',
    component: () => import('@/views/Bari/bari.vue'),
  },
  {
    path: '/online',
    name: 'Online',
    component: () => import('@/views/Online/online.vue'),
  },
  {
    path: '/homes',
    name: 'Homes',
    component: () => import('@/views/Homes/homes.vue'),
    meta: {
      activeNum: 0,
      show: true,
      title: '卫蓝e站',
    },
  },
  {
    path: '/example',
    name: 'Example',
    component: () => import('@/views/Example/example.vue'),
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/views/Order/order.vue'),
  },
  {
    path: '/webPng',
    name: 'WebPng',
    component: () => import('@/views/webPng/webPng.vue'),
  },
  {
    path: '/esitamition',
    name: 'Esitamition',
    component: () => import('@/views/Esitamition/esitamition.vue'),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('user-token')
  // if (to.path == '/sgs') {
  //   next();
  // } else
  if (to.path == '/homes') {
    if (token) {
      next()
    } else {
      Vue.prototype.$toast('请先登录')
      setTimeout(() => {
        next('/login')
      }, 2000)
    }
  } else {
    next()
  }
  if (to.meta?.title) {
    document.title = to.meta.title
  }
})

export default router
